import { render } from "./BuyerDetails.vue?vue&type=template&id=fe2eddd0&scoped=true&lang=pug"
import script from "./BuyerDetails.vue?vue&type=script&lang=ts"
export * from "./BuyerDetails.vue?vue&type=script&lang=ts"

import "./BuyerDetails.vue?vue&type=style&index=0&id=fe2eddd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fe2eddd0"

export default script